<template>
  <div class="promoted-articles my-3" v-if="data">
      <div class="d-flex justify-content-between">
        <h3 class="promoted-title text-20">{{ data.title }}</h3>
        <div v-if="showControls" class="slides-controls d-flex flex-row justify-content-around">
          <div class="arrow-prev" @click="showPrev">
           <i class="icon-arrow-left xs"></i>
          </div>
          <div class="arrow-next" @click="showNext">
            <i class="icon-arrow-right xs"></i>
          </div>
        </div>
      </div>
      <VueSlickCarousel v-bind="settings" ref="carousel">
        <div
          v-for="(article, index) in data.articles"
          :key="index"
          class="promoted-article"
        >
          <ArticleComponent :article="article" type="promoted"/>
        </div>
      </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import ArticleComponent from './ArticleComponent.vue'
export default {
  name: 'MyComponent',
  components: {
    VueSlickCarousel,
    ArticleComponent
  },
  props: {
    data: Object,
    isMobile: Boolean
  },
  data () {
    return {
      settings: {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 980,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ],
        slide: 0,
        sliding: null
      },
      isWideScreen: false
    }
  },
  methods: {
    showNext () {
      this.$refs.carousel.next()
    },
    showPrev () {
      this.$refs.carousel.prev()
    }
  },
  computed: {
    showControls () {
      if (this.data.articles.length > 3) {
        return true
      } else if ((this.isMobile || !this.isWideScreen) && this.data.articles.length >= 2) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (window.innerWidth >= 1200) {
      this.isWideScreen = true
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 1200) {
        this.isWideScreen = false
      } else {
        this.isWideScreen = true
      }
    })
  }
}
</script>
<style lang="scss" >
.promoted-articles {
  background: #eeeef1;
  padding: 20px;
  border: 1px solid transparent;
  border-radius: 5px;
  .promoted-title {
    position: relative;
  }
  .promoted-article {
    max-width: 340px;
    word-wrap: normal;
  }
  .slides-controls{
    min-width: 100px;
    .arrow-prev,.arrow-next{
      border: 2px solid;
      border-radius:50%;
      height: 40px;
      width: 40px;
      align-content: center;
      display: flex;
      justify-content: center;
      .icon-arrow-left,.icon-arrow-right{
        align-self: center;
        cursor: pointer;
      }
    }
  }
  .slick-arrow {
    display: none!important;
    pointer-events: none!important;
  }
  .slick-list {
    margin: 0;
    .slick-current{
      @media (max-width: 992px){
        max-width: 355px;
      }
      @media (max-width: 440px){
        max-width: 245px;
      }
    }
  }
}
</style>
